/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.directives.module.ts" />
/// <reference path="../services/usermessagesservice.ts" />
/// <reference path="../controllers/usermessagescontroller.ts" />

module App.Common.Directives {
	'use strict';

	class UserMessagesDirective implements angular.IDirective {

		public restrict = 'E';

		public controller = Common.Controllers.UserMessagesController;

		public controllerAs = 'vm';

		public bindToController = true;

		public scope = {} as { [boundProperty: string]: string };

		public templateUrl = 'Templates/Common/UserMessagesView.html';

	}

	angular
		.module('app.common.directives')
		.directive('userMessages', () => {return new UserMessagesDirective();});
}